export const tabs = [
  'media',
  'welcome',
  'details',
  'policies',
  'registration',
  'participants',
  'live',
  'results',
  'volunteers',
  'contact',
  'links'
]
